module.exports = __webpack_public_path__ + "img/B553.1c245377.jpg";